"use client";

import React from 'react';
import { Coins, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUser } from '@/context/userContext';
import { cn } from '@/lib/utils';

interface CoinBalanceProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showRefresh?: boolean;
}

export function CoinBalance({ className, size = 'md', showRefresh = true }: CoinBalanceProps) {
  const { coinBalance, refreshBalance, isLoading } = useUser();

  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-2', 
    lg: 'text-base px-4 py-3'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <div className={cn(
      "flex items-center gap-2 bg-gradient-to-r from-yellow-50 to-amber-50 border border-yellow-200 rounded-lg",
      sizeClasses[size],
      className
    )}>
      <Coins className={cn("text-yellow-600", iconSizes[size])} />
      <span className="font-medium text-yellow-800">
        {isLoading ? '...' : coinBalance}
      </span>
      <span className="text-yellow-600 text-xs">
        {coinBalance === 1 ? 'coin' : 'coins'}
      </span>
      
      {showRefresh && (
        <Button
          variant="ghost"
          size="sm"
          onClick={refreshBalance}
          className="h-auto p-1 ml-1 hover:bg-yellow-100"
          disabled={isLoading}
        >
          <RefreshCw className={cn(
            "text-yellow-600",
            iconSizes[size],
            isLoading && "animate-spin"
          )} />
        </Button>
      )}
    </div>
  );
}
